// v2019-09-11
const application = process.env.VUE_APP_APPLICATION_NAME;

import MarkdownIt from "markdown-it";
import mdfigcaption from "mdfigcaption";
import markdownItFootnote from "markdown-it-footnote";
import markdownItAttrs from "markdown-it-attrs";
import markdownItContainer from "markdown-it-container";
import markdownItFa from "markdown-it-fontawesome";
import markdownItVideo from "markdown-it-video";

const md = new MarkdownIt({
  html: false,
  linkify: true,
  typographer: true
});

const mdIt = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true
})
  .use(mdfigcaption)
  .use(markdownItFootnote)
  .use(markdownItAttrs)
  .use(markdownItContainer, "div")
  .use(markdownItFa)
  .use(markdownItVideo);

const markdown = raw => {
  return md.render(raw);
};

const markdownIt = raw => {
  let html = mdIt.render(raw);
  html = html.replace(
    /<table>/gi,
    '<table style="width: auto" class="table table-sm table-striped">'
  );
  return html;
};

const urlDisplay = url => {
  return url.replace(/http(s?):\/\/(www\.)?/, "");
};

const toLowerCase = s => {
  return s ? s.toLowerCase() : s;
};

const slugify = s => {
  return s ? s.replace(/\W+/g, "-").toLowerCase() : null;
};

const pageData = title => {
  document.title = title ? `${title} | ${application}` : application;
};

let embers = {
  markdown: markdown,
  markdownIt: markdownIt,
  urlDisplay: urlDisplay,
  pageData: pageData,
  toLowerCase: toLowerCase,
  slugify: slugify
};

embers.install = Vue => {
  Vue.prototype.$embers = embers;
};

export default embers;
